@if (DischargeTypeData?.count! > 0) {
  <div
    id="divChart"
    class="chart-container"
    >
    <canvas id="dischargeType"> </canvas>
  </div>
}
